export default __webpack_public_path__ + "static/media/wyspa_sw_edwarda_kanada.dcd6063a.jpg";